import { render, staticRenderFns } from "./GridContainer.vue?vue&type=template&id=8b66ff1e&"
import script from "./GridContainer.vue?vue&type=script&lang=ts&"
export * from "./GridContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports